import React from "react";
import { Form } from "react-bootstrap";
import { getImageUrl } from "../../../utils/imageUrl";
import { PermissionWrapper } from "../../PermissionWrapper/PermissionWrapper";

interface UserTableActionsProps {
  isActive: boolean;
  onView?: () => void;
  onEdit?: () => void;
  onAddUser?: () => void;
  onToggleStatus?: (checked: boolean) => void;
}

const UserTableActions: React.FC<UserTableActionsProps> = ({
  isActive,
  onView,
  onEdit,
  onAddUser,
  onToggleStatus,
}) => {
  return (
    <div className="user-table-actions">
      <div className="user-table-actions-icons">
        {/* View is always allowed; view-only users see only this action */}
        <button
          type="button"
          className="user-table-action-btn"
          title="View"
          onClick={onView}
        >
          <img
            src={getImageUrl("shared/assets/icons/eye_outlined.svg")}
            alt="View"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = "none";
              const fallback = document.createElement("i");
              fallback.className = "ph-eye";
              target.parentElement?.appendChild(fallback);
            }}
          />
        </button>

        {/* Edit + Assign role require manage-level permissions */}
        <PermissionWrapper
          anyOfPermissions={[
            "access_management.admin",
            "access_management.users.manage",
          ]}
          hideWhenDisabled
        >
          <>
            {/* Edit user details (opens side drawer) */}
            <button
              type="button"
              className="user-table-action-btn"
              title="Edit user"
              onClick={onEdit}
            >
              <img
                src={getImageUrl("shared/assets/icons/edit-outlined.svg")}
                alt="Edit user"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = "none";
                  const fallback = document.createElement("i");
                  fallback.className = "ri-edit-line";
                  target.parentElement?.appendChild(fallback);
                }}
              />
            </button>

            {/* Assign / manage roles */}
            <button
              type="button"
              className="user-table-action-btn"
              title="Assign role"
              onClick={onAddUser}
            >
              <img
                src={getImageUrl("shared/assets/icons/add_user.svg")}
                alt="Assign role"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.style.display = "none";
                  const fallback = document.createElement("i");
                  fallback.className = "ph-user-plus";
                  target.parentElement?.appendChild(fallback);
                }}
              />
            </button>
          </>
        </PermissionWrapper>
      </div>
      <PermissionWrapper
        anyOfPermissions={[
          "access_management.admin",
          "access_management.users.manage",
        ]}
        hideWhenDisabled
      >
        <Form.Check
          type="switch"
          className="user-table-status-toggle"
          checked={isActive}
          onChange={(e) => onToggleStatus?.(e.target.checked)}
          aria-label="Toggle user status"
        />
      </PermissionWrapper>
    </div>
  );
};

export default UserTableActions;
